import { type FC } from "react";
import { Link } from "react-router-dom";
import { AlertCircle } from "lucide-react";

import logoFull from "@/shared/assets/logo/logo-full.svg";

interface ClientInviteErrorProps {
  type: "invalid" | "expired" | "accepted";
}

const ERROR_CONTENT: Record<
  ClientInviteErrorProps["type"],
  { title: string; description: string }
> = {
  invalid: {
    title: "Invitation not found",
    description:
      "This invitation link is invalid or has been cancelled. Please contact your attorney for a new invitation.",
  },
  expired: {
    title: "Invitation expired",
    description:
      "This invitation has expired. Please contact your attorney to resend the invitation.",
  },
  accepted: {
    title: "Invitation already accepted",
    description:
      "This invitation has already been accepted. You can sign in to access your estate workspace.",
  },
};

export const ClientInviteError: FC<ClientInviteErrorProps> = ({ type }) => {
  const content = ERROR_CONTENT[type];

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-subtle px-6">
      <img src={logoFull} alt="Elayne" className="absolute left-4 top-4 h-8 sm:left-8 sm:top-8" />
      <div className="flex max-w-md flex-col items-center gap-6 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full border border-primary bg-white">
          <AlertCircle className="h-6 w-6 text-secondary" />
        </div>
        <div className="flex flex-col gap-3">
          <h2>{content.title}</h2>
          <p className="text-secondary">{content.description}</p>
        </div>
        {type === "accepted" && (
          <Link
            to="/login"
            className="rounded-full bg-brand px-6 py-2 text-sm font-medium text-white"
          >
            Sign in
          </Link>
        )}
      </div>
    </div>
  );
};
